export default "__VITE_ASSET__BsHufd1k__"